import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UserGroupEntity } from '../../domain/entities/UserGroupEntity'

export class UserGroupModel extends UserGroupEntity {
  constructor(dataDto: UserGroupModel) {
    super()
    mapEntityProperties<UserGroupEntity>(this, dataDto)
  }
}
